import * as Joi from 'joi';

export const categoryCreateUpdateSchema = Joi.object({
  name: Joi.string().required().min(2).max(255),
});
